import { ReactNode } from "react";

/**
 * Lightweight CSS page transition — replaces framer-motion AnimatePresence.
 * Uses CSS @keyframes for zero-JS animation cost.
 */
const PageTransition = ({ children }: { children: ReactNode }) => (
  <div className="animate-page-in">
    {children}
  </div>
);

export default PageTransition;
